exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".params {\n  margin: 24px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/select-params/select-params.component.less
// module id = 1456
// module chunks = 2